import type { Mode } from '@tarot/shared';

/**
 * 모드 아이콘 — 인라인 SVG 라인아트 (골드 카드 + 별).
 * 이모지와 달리 Android/iOS/PC 어디서나 동일하게 렌더링됨.
 * 색은 currentColor — 사용처에서 text-gold 등으로 지정.
 */
export function ModeIcon({ mode, className = 'h-10 w-10' }: { mode: Mode; className?: string }) {
  const common = {
    viewBox: '0 0 48 48',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinejoin: 'round' as const,
    strokeLinecap: 'round' as const,
    className,
    'aria-hidden': true,
  };

  switch (mode) {
    // 나 혼자 — 카드 한 장 + 빛나는 별
    case 'solo':
      return (
        <svg {...common}>
          <rect x="16" y="9" width="16" height="27" rx="2.5" />
          <Star cx={24} cy={22.5} r={5} />
          {/* 별빛 */}
          <path d="M24 12.5v2M24 30.5v2M17.5 22.5h-2M32.5 22.5h-2" strokeWidth="1.2" opacity="0.7" />
        </svg>
      );

    // 커플 — 기대어 있는 카드 두 장 + 하트
    case 'couple':
      return (
        <svg {...common}>
          <g transform="rotate(-12 18 24)">
            <rect x="10" y="11" width="15" height="25" rx="2.5" />
          </g>
          <g transform="rotate(12 30 24)">
            <rect x="23" y="11" width="15" height="25" rx="2.5" />
          </g>
          <path
            d="M24 29.2c-2.2-2.4-5.2-0.9-5.2 1.2 0 1.9 2.4 3.5 5.2 5.6 2.8-2.1 5.2-3.7 5.2-5.6 0-2.1-3-3.6-5.2-1.2z"
            fill="currentColor"
            stroke="none"
            opacity="0.9"
          />
          <Star cx={24} cy={17.5} r={3} />
        </svg>
      );

    // 우정 — 부채꼴로 펼친 카드 세 장 + 별
    case 'friends':
      return (
        <svg {...common}>
          <g transform="rotate(-22 24 38)">
            <rect x="16.5" y="12" width="15" height="25" rx="2.5" />
          </g>
          <g transform="rotate(22 24 38)">
            <rect x="16.5" y="12" width="15" height="25" rx="2.5" />
          </g>
          {/* 카드 앞면 바탕 — 테마 토큰(라이트/다크 자동). SVG 속성 대신 style이라야 var()가 확실히 먹음 */}
          <rect
            x="16.5"
            y="9.5"
            width="15"
            height="25"
            rx="2.5"
            style={{ fill: 'var(--color-card-back)' }}
          />
          <Star cx={24} cy={22} r={4.5} />
        </svg>
      );
  }
}

/** 4각 별(스파클) — 브랜드 모티프 */
function Star({ cx, cy, r }: { cx: number; cy: number; r: number }) {
  const k = r * 0.22;
  return (
    <path
      d={`M${cx} ${cy - r} L${cx + k} ${cy - k} L${cx + r} ${cy} L${cx + k} ${cy + k} L${cx} ${cy + r} L${cx - k} ${cy + k} L${cx - r} ${cy} L${cx - k} ${cy - k} Z`}
      fill="currentColor"
      stroke="none"
    />
  );
}
